import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-incidents-container',
  templateUrl: './incidents-container.component.html',
  styleUrls: ['./incidents-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class IncidentsContainerComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
